import React from "react";
import PropTypes from "prop-types";

export const TitleElements = ({ icon: IconComponent, title, subtitle }) => {
    return (
        <div className="header_icon">
            {IconComponent && <IconComponent className="header_icons" style={{ color: "#284945" }} />}
            <h3 style={{ color: "#284945" }}> {title}</h3>
        </div >
    );
};

// Përdorimi i PropTypes për të siguruar që të kalohen të dhënat e duhura
TitleElements.propTypes = {
    icon: PropTypes.elementType,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
};


export const ElementsParagraph = ({ text }) => {
    return (
        <div className="header_paragraph">
            <p style={{ color: "#4E7B67" }}>{text}</p>
        </div>
    );
};

// Përdorimi i PropTypes për të siguruar që `text` është një string
ElementsParagraph.propTypes = {
    text: PropTypes.string.isRequired,
};
